import { render, staticRenderFns } from "./manageRigTerrain.vue?vue&type=template&id=9299a12c"
import script from "./manageRigTerrain.vue?vue&type=script&lang=ts"
export * from "./manageRigTerrain.vue?vue&type=script&lang=ts"
import style0 from "./manageRigTerrain.vue?vue&type=style&index=0&id=9299a12c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports